"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconTooltip = void 0;
var React = require("react");
var IconTooltip_st_css_1 = require("./IconTooltip.st.css");
var button_next_1 = require("wix-ui-core/button-next");
var react_uid_1 = require("react-uid");
var Tooltip_1 = require("../Tooltip");
var TooltipEnums_1 = require("../Tooltip/TooltipEnums");
/** An icon that shows a tooltip on focus and on hover. */
var IconTooltip = /** @class */ (function (_super) {
    __extends(IconTooltip, _super);
    function IconTooltip() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IconTooltip.prototype.render = function () {
        var _a = this.props, message = _a.message, icon = _a.icon, tooltipId = _a.tooltipId, tooltipSkin = _a.tooltipSkin, showTooltip = _a.showTooltip, onClickOutside = _a.onClickOutside, tooltipProps = _a.tooltipProps, dataHook = _a["data-hook"], rest = __rest(_a, ["message", "icon", "tooltipId", "tooltipSkin", "showTooltip", "onClickOutside", "tooltipProps", 'data-hook']);
        var content = React.createElement("span", { id: tooltipId }, message);
        return (React.createElement(Tooltip_1.Tooltip, __assign({ className: IconTooltip_st_css_1.classes.root, "data-hook": dataHook, "aria-live": "polite", disabled: !showTooltip, content: content, appendTo: "scrollParent", skin: tooltipSkin, shown: showTooltip, onClickOutside: onClickOutside, disableClickOutsideWhenClosed: true }, tooltipProps),
            React.createElement(React.Fragment, null,
                React.createElement(button_next_1.ButtonNext, __assign({ className: IconTooltip_st_css_1.classes.button, "aria-pressed": showTooltip, "aria-labelledby": tooltipId }, rest),
                    React.createElement("div", { className: IconTooltip_st_css_1.classes.icon }, icon)),
                !showTooltip ? (React.createElement("span", { id: tooltipId, className: IconTooltip_st_css_1.classes.tooltipMessage }, message)) : null)));
    };
    IconTooltip.displayName = 'IconTooltip';
    IconTooltip.defaultProps = {
        message: '',
        icon: undefined,
        tooltipId: react_uid_1.uid(IconTooltip.displayName),
        tooltipSkin: TooltipEnums_1.TooltipSkin.Standard,
        showTooltip: false,
    };
    return IconTooltip;
}(React.Component));
exports.IconTooltip = IconTooltip;
//# sourceMappingURL=IconTooltip.js.map